import { render, staticRenderFns } from "./shopPaymentConfig.vue?vue&type=template&id=f31a49f6&"
import script from "./shopPaymentConfig.vue?vue&type=script&lang=js&"
export * from "./shopPaymentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports